import { useSyncExternalStore } from 'react';
import type { AufgeloesterKatalog } from '../../services/mangelKatalog/typen';

/**
 * Was jede Mangelkarte vom Geraet und vom Mängelkatalog braucht. Die Liste
 * ermittelt es EINMAL und reicht es allen Karten durch: 600 Karten der
 * Historie hielten sonst je einen Resize-, zwei Netz- und einen
 * Katalog-Zuhoerer (ueber 1800) — und am Android-Handy loest schon das
 * Einblenden der Tastatur ein Resize aus.
 *
 * Ohne Umgebung (Freelancer-Portal, Einzeltests) ermittelt die Karte sie
 * selbst (InspectionItemCard).
 */
export interface KartenUmgebung {
    isMobile: boolean;
    /** Netzstatus fuer den KI-Knopf: ohne Netz gibt es keinen Vorschlag. */
    online: boolean;
    /** Aufgeloester Katalog in der Katalogsprache des Berichts (katalogSprache). */
    katalog: AufgeloesterKatalog;
}

const netzAbonnieren = (melden: () => void) => {
    window.addEventListener('online', melden);
    window.addEventListener('offline', melden);
    return () => {
        window.removeEventListener('online', melden);
        window.removeEventListener('offline', melden);
    };
};
const netzDa = () => navigator.onLine !== false;

/** Netzstatus als React-Zustand (ohne DOM: immer „da“). */
export const useNetzDa = (): boolean => useSyncExternalStore(netzAbonnieren, netzDa, () => true);
